<div *ngIf="reportType == 'Briefly-Officer'">
    <div class="container" id="print-section">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="2">Vivek Saptahik</th>
                    <th colspan="3">Book Payment Receipt Ledger</th>
                    <th colspan="1">Briefly-Rep-Officer</th>
                    <!-- <th colspan="1">Date</th> -->
                </tr>
                <tr>
                    <th colspan="2">Datewise</th>
                    <th colspan="4">From {{startDate | date: 'dd-MM-yyyy'}} To {{endDate | date: 'dd-MM-yyyy'}}</th>
                    <!-- <th colspan="1">Page No</th> -->
                </tr>
                <tr>
                    <th>Receipt No</th>
                    <th>Receipt Date</th>
                    <!-- <th>Entry Date</th> -->
                    <th>Advertiser Name</th>
                    <th>Representative Name</th>
                    <th>Office Representative Name</th>
                    <th>Received Amount</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let data of bookOfficierbrieflyFormBeans; let i = index">
                    <tr>
                        <td colspan="2" style="font-weight: bold; font-size: 15px;">Representative</td>
                        <td colspan="1" style="font-weight: bold; font-size: 15px;">{{data.rep_name}}</td>
                        <td colspan="3"></td>
                    </tr>
                    <tr *ngFor="let data2 of data.rep_data; let j = index">
                        <td>{{data2.receipt_no}}</td>
                        <td>{{data2.receipt_date}}</td>
                        <!-- <td>{{data2.entry_date}}</td> -->
                        <td>{{data2.book_seller_name}}</td>
                        <td>{{data2.rep_name}}</td>
                        <td>{{data2.office_rep_name}}</td>
                        <td style="text-align: end;">{{data2.select_entry_amt}}</td>
                    </tr>
                    <tr>
                        <td colspan="5" style="font-weight: bold; font-size: 16px;">Total</td>
                        <td style="text-align: end; font-weight: bold; font-size: 16px;">{{data.total_amt}}</td>
                    </tr>
                </ng-container>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="4" style="font-weight: bold;">Total:</td>
                    <td colspan="2" style="font-weight: bold; text-align: end;">{{bookOfficierbrieflyTotal | number:'1.2-2' }}</td>
                </tr>
            </tfoot>
        </table>
    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Rep_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>

       <button class="noPrint" style="margin-top: 2%;" id="print-button" mat-raised-button color="primary" printSectionId="print-section"
          [useExistingCss]="true" ngxPrint style="display: none;">Print</button>
  
        <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
          Print
        </button>
        
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>
